module.exports = __webpack_public_path__ + "static/img/6.8a2bc2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/hospital1/6.png
// module id = 1/tS
// module chunks = 1